import {FC} from 'react'

import cn from 'classnames/bind'
import Image from 'next/legacy/image'

import LandingsTitle from 'components/blocks/LandingsTitle'
import PortableBlocks from 'components/blocks/PortableBlocks'
import {Container} from 'components/elements/grid'
import {IW2Content} from 'pages/make-your-w2'
import {BlockContent} from 'src/types/__sanitySchema__'

import s from './W2Users.module.scss'
const cx = cn.bind(s)

interface IW2UsersProps {
	className?: string
	content: IW2Content['users']
}

/** W2Users block component */
const W2Users: FC<IW2UsersProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} />

				{content?.items?.map((item) => (
					<W2UsersItem
						key={item._key}
						{...{item: {...item, icon: item.icon as unknown as string}}}
					/>
				))}
			</Container>
		</div>
	)
}

W2Users.displayName = 'W2Users'

export default W2Users

interface IW2UsersItem {
	item: {title?: string; description?: BlockContent; icon?: string}
}

function W2UsersItem({item}: IW2UsersItem) {
	return (
		<div className={s.item}>
			<div className={cx('item__icon')}>
				{item.icon && <Image layout="fixed" src={item.icon} width={88} height={88} alt="" />}
			</div>
			<div className={cx('item__content')}>
				<p className={cx('item__title', 'h3')}>{item.title}</p>
				{item.description && (
					<PortableBlocks className={cx('item__blockContent')} blockContent={item.description} />
				)}
			</div>
		</div>
	)
}
